import styled from 'styled-components';
import { Modal, Space } from 'antd';

export const AddProductsFromMfrChoiceTemplateModal = styled(Modal)`
    width: 680px !important;
    height: 347px !important;

    .ant-modal-body {
        padding: 32px 40px 41px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }
`;

export const AddFromMfrChoiceTemplateSpace = styled(Space)`
    margin-top: 16px;
    align-items: end;
    width: 100%;
    .ant-space-item:first-child {
        width: 70%;
    }
`;

export const ModalFooterBlocker = styled.div<{ $blocked: boolean }>`
    pointer-events: ${({ $blocked }) => ($blocked ? 'none' : 'auto')};
    opacity: ${({ $blocked }) => ($blocked ? 0.6 : 1)};
`;
